require(
      "!../gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!./app-shell.js") })
        }
      }, "component---node-modules-gatsby-plugin-offline-app-shell-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---node-modules-gatsby-plugin-offline-app-shell-js!./~/gatsby-plugin-offline/app-shell.js
// module id = 536
// module chunks = 231608221292675